import { Injectable, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { ConfigApi } from './config-api.model';

@Injectable()
export class ConfigUrlProvider implements OnInit {
    private configApi: ConfigApi;

    ngOnInit(): void {
        this.configApi = null;
    }

    constructor(private http: Http) {
    }

    public getConfigApi(): ConfigApi {
        return this.configApi;
    }

    load() {
        return new Promise((resolve, reject) => {
            this.http
                .get('assets/config.json')
                .map(res => res.json())
                .subscribe(response => {
                    this.configApi = response;
                    resolve(true);
                })
        });
    }
}


// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/shared/configurl-provider.ts